// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><defs><pattern id=\"grain\" width=\"100\" height=\"100\" patternUnits=\"userSpaceOnUse\"><circle cx=\"25\" cy=\"25\" r=\"1\" fill=\"rgba%28255,255,255,0.1%29\"/><circle cx=\"75\" cy=\"75\" r=\"1\" fill=\"rgba%28255,255,255,0.1%29\"/><circle cx=\"50\" cy=\"10\" r=\"0.5\" fill=\"rgba%28255,255,255,0.05%29\"/><circle cx=\"10\" cy=\"50\" r=\"0.5\" fill=\"rgba%28255,255,255,0.05%29\"/><circle cx=\"90\" cy=\"30\" r=\"0.5\" fill=\"rgba%28255,255,255,0.05%29\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url%28%23grain%29\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow: hidden;
}

.login-background {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 400px;
  padding: 20px;
}

.login-background::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  animation: float 20s ease-in-out infinite;
  z-index: -1;
}

@keyframes float {
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(180deg); }
}

.login-card-wrapper {
  position: relative;
}

.login-card {
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.95);
  overflow: hidden;
}

.login-header {
  text-align: center;
  margin-bottom: 32px;
  padding: 20px 0;
}

.login-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 16px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: white;
  box-shadow: 0 8px 16px rgba(102, 126, 234, 0.3);
}

.login-title {
  margin: 0 !important;
  color: #262626;
  font-weight: 600;
}

.login-form {
  padding: 0 8px;
}

.login-form .ant-form-item {
  margin-bottom: 24px;
}

.login-form .ant-input-affix-wrapper,
.login-form .ant-input {
  border-radius: 8px;
  border: 2px solid #f0f0f0;
  transition: all 0.3s ease;
}

.login-form .ant-input-affix-wrapper:focus,
.login-form .ant-input-affix-wrapper-focused,
.login-form .ant-input:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}

.login-button {
  height: 48px;
  border-radius: 8px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border: none;
  font-size: 16px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  transition: all 0.3s ease;
}

.login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
  background: linear-gradient(135deg, #764ba2, #667eea);
}

.login-footer {
  text-align: center;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.default-account {
  font-size: 12px;
  color: #999;
  background: #f9f9f9;
  padding: 8px 12px;
  border-radius: 6px;
  display: inline-block;
}

@media (max-width: 768px) {
  .admin-login-container {
    padding: 20px;
  }
  
  .login-background {
    max-width: 100%;
  }
  
  .login-card {
    margin: 0;
  }
  
  .login-icon {
    width: 60px;
    height: 60px;
    font-size: 24px;
  }
  
  .login-title {
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Admin/Login.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mDAAsjB;EACtjB,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,WAAW,uCAAuC,EAAE;EACpD,MAAM,2CAA2C,EAAE;AACrD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,2BAA2B;EAC3B,0CAA0C;EAC1C,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;EAGE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".admin-login-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  position: relative;\n  overflow: hidden;\n}\n\n.login-background {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 400px;\n  padding: 20px;\n}\n\n.login-background::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  width: 200%;\n  height: 200%;\n  background: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><defs><pattern id=\"grain\" width=\"100\" height=\"100\" patternUnits=\"userSpaceOnUse\"><circle cx=\"25\" cy=\"25\" r=\"1\" fill=\"rgba(255,255,255,0.1)\"/><circle cx=\"75\" cy=\"75\" r=\"1\" fill=\"rgba(255,255,255,0.1)\"/><circle cx=\"50\" cy=\"10\" r=\"0.5\" fill=\"rgba(255,255,255,0.05)\"/><circle cx=\"10\" cy=\"50\" r=\"0.5\" fill=\"rgba(255,255,255,0.05)\"/><circle cx=\"90\" cy=\"30\" r=\"0.5\" fill=\"rgba(255,255,255,0.05)\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url(%23grain)\"/></svg>');\n  animation: float 20s ease-in-out infinite;\n  z-index: -1;\n}\n\n@keyframes float {\n  0%, 100% { transform: translateY(0px) rotate(0deg); }\n  50% { transform: translateY(-20px) rotate(180deg); }\n}\n\n.login-card-wrapper {\n  position: relative;\n}\n\n.login-card {\n  border-radius: 16px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  background: rgba(255, 255, 255, 0.95);\n  overflow: hidden;\n}\n\n.login-header {\n  text-align: center;\n  margin-bottom: 32px;\n  padding: 20px 0;\n}\n\n.login-icon {\n  width: 80px;\n  height: 80px;\n  margin: 0 auto 16px;\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 32px;\n  color: white;\n  box-shadow: 0 8px 16px rgba(102, 126, 234, 0.3);\n}\n\n.login-title {\n  margin: 0 !important;\n  color: #262626;\n  font-weight: 600;\n}\n\n.login-form {\n  padding: 0 8px;\n}\n\n.login-form .ant-form-item {\n  margin-bottom: 24px;\n}\n\n.login-form .ant-input-affix-wrapper,\n.login-form .ant-input {\n  border-radius: 8px;\n  border: 2px solid #f0f0f0;\n  transition: all 0.3s ease;\n}\n\n.login-form .ant-input-affix-wrapper:focus,\n.login-form .ant-input-affix-wrapper-focused,\n.login-form .ant-input:focus {\n  border-color: #667eea;\n  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);\n}\n\n.login-button {\n  height: 48px;\n  border-radius: 8px;\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  border: none;\n  font-size: 16px;\n  font-weight: 600;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n  transition: all 0.3s ease;\n}\n\n.login-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);\n  background: linear-gradient(135deg, #764ba2, #667eea);\n}\n\n.login-footer {\n  text-align: center;\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid #f0f0f0;\n}\n\n.default-account {\n  font-size: 12px;\n  color: #999;\n  background: #f9f9f9;\n  padding: 8px 12px;\n  border-radius: 6px;\n  display: inline-block;\n}\n\n@media (max-width: 768px) {\n  .admin-login-container {\n    padding: 20px;\n  }\n  \n  .login-background {\n    max-width: 100%;\n  }\n  \n  .login-card {\n    margin: 0;\n  }\n  \n  .login-icon {\n    width: 60px;\n    height: 60px;\n    font-size: 24px;\n  }\n  \n  .login-title {\n    font-size: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
